import en from './en'
import zh from './zh'
import { createI18n } from 'vue-i18n' //引入vue-i18n组件

const i18n = createI18n({
  legacy: false,
  globalInjection:true,
  locale: "ZH",
  fallbackLocale: "ZH",
  messages: {
    ZH: zh,
    EN: en
  }
})

export default i18n
